<template>
    <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
        <div style="display: flex; width: 100%; flex-shrink: 0">
            <div class="filter-bar" ref="filterBar">
                <!-- 查询条件容器：分为两行布局，左右对称结构（筛选左 + 操作右） -->
                <!-- 第一行：商户 + 日期类条件（左侧） · 导出按钮（右侧靠右收尾） -->

                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择商户" style="width: 160px;;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.acrYearMonthExchange" type="month" value-format="yyyyMM"
                        placeholder="核销时间" style="width: 140px;" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.acrYearMonth" type="month" value-format="yyyyMM"
                        placeholder="制卡时间" style="width: 140px;" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="制卡开始时间" style="width: 160px;" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="制卡结束时间" style="width: 160px;" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateCheckStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="核销开始时间" style="width: 160px;" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.dateCheckEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="核销结束时间" style="width: 160px;" size="mini" clearable @change="partserch">
                    </el-date-picker>

                    <el-input v-model="formDatas.acrPhone" style="width: 130px;;" size="mini"
                        placeholder="手机号" clearable></el-input>
                    <el-input v-model="formDatas.acrAmount" style="width: 130px;;" size="mini"
                        placeholder="卡劵金额" clearable></el-input>
                    <el-input v-model="formDatas.acrCode" style="width: 130px;;" size="mini"
                        placeholder="卡劵号码" clearable></el-input>
                    <el-select size="mini" v-model="formDatas.acrCodeType" clearable @change="partserch"
                        placeholder="请选择劵码类型" style="width: 140px;;">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <!-- 券码对账核查状态：0不需要 1待处理 2已处理 3有问题 4已解决 -->
                    <el-select size="mini" v-model="formDatas.acrCheckHandlerStatus" clearable @change="partserch"
                        placeholder="对账核查状态" style="width: 140px;;">
                        <el-option label="不需要" :value="0"></el-option>
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已处理" :value="2"></el-option>
                        <el-option label="有问题" :value="3"></el-option>
                        <el-option label="已解决" :value="4"></el-option>
                    </el-select>
                    <!-- 券码对账核查描述：与核查状态同属对账维度，紧随其后展示 -->
                    <el-input v-model="formDatas.acrCheckHandlerDes" style="width: 140px;;"
                        size="mini" placeholder="对账核查描述" clearable></el-input>
                    <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 140px;;">
                        <el-option label="分账" :value="5"></el-option>
                        <el-option label="退款" :value="6"></el-option>
                    </el-select>
                    <!-- 批量处理：基于表格多选，提交所选 id 集合（仅 auId=1/2 可见） -->
                    <div class="filter-actions">
                        <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
                        <el-button v-if="checkOperateAuth" type="primary" size="mini" @click="openCheckHandlerBatch">批量处理</el-button>
                        <el-button type="warning" size="mini" icon="el-icon-download" @click="Out()">导出</el-button>
                    </div>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div class="table-wrap" ref="tableWrap">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="acrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑卡劵' : '新增卡劵'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="卡劵规格" prop="acrrxId">
                                <el-select v-model="form.acrrxId" filterable clearable placeholder="请选择"
                                    style="width: 80%;">
                                    <el-option
                                        v-for="(item, index) in getAjefCertificateRecordRelationXiaoxiangList_data"
                                        :key="index" :label="item.acrAmount + '元'" :value="item.acrrxId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生成数量" prop="number">
                                <el-input type="number" v-model="form.number" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="烟感卡劵核销详情" :visible.sync="diaDetail" width="60%">
                <el-table :data="tableDataDetail" stripe border style="width: 100%" :max-height="400"
                    :cell-style="{ textAlign: 'center' }" :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none',
                    }">
                    <el-table-column prop="userName" label="用户姓名" width="200">
                    </el-table-column>
                    <el-table-column prop="userPhone" label="用户手机号" width="200">
                    </el-table-column>
                    <el-table-column prop="userAddress" label="用户地址">
                    </el-table-column>
                    <el-table-column prop="userState" label="同步状态" width="150">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    scope.row.userState == 1 ? '未同步' :
                                        scope.row.userState == 2 ? '已同步' : ''
                                }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="diaDetail = false">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 券码对账核查-处理弹窗 -->
            <el-dialog :title="checkHandlerMode === 'batch' ? '批量券码对账核查处理' : '券码对账核查处理'"
                :visible.sync="checkHandlerDialog" width="500px" :before-close="closeCheckHandler">
                <el-form :model="checkHandlerForm" label-width="100px" size="mini">
                    <el-form-item label="核查状态">
                        <el-select v-model="checkHandlerForm.acrCheckHandlerStatus" placeholder="请选择"
                            style="width: 100%">
                            <el-option label="已解决" :value="4"></el-option>
                            <el-option label="已处理" :value="2"></el-option>
                            <el-option label="待处理" :value="1"></el-option>
                            <el-option label="不需要" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="核查描述">
                        <el-input type="textarea" :rows="3" v-model="checkHandlerForm.acrCheckHandlerDes"
                            placeholder="请输入核查描述" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="closeCheckHandler">取 消</el-button>
                    <el-button size="mini" type="primary" @click="sureCheckHandler">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 券码对账核查-关联订单和账单弹窗 -->
            <el-dialog title="关联订单和账单" :visible.sync="checkOrderBillDialog" width="70%"
                :before-close="closeCheckOrderBill" append-to-body>
                <div style="margin-bottom: 12px;">
                    <el-button size="mini" @click="queryCheckOrderBill(checkOrderBillRow.acrId)"
                        icon="el-icon-refresh">刷新</el-button>
                </div>
                <!-- 关联订单/账单信息：以 JSON 格式直接展示完整响应 -->
                <div v-loading="checkOrderBillLoading" element-loading-text="加载中..."
                    style="min-height: 200px; max-height: 500px; overflow: auto; background: #f5f7fa;
                    border: 1px solid #ebeef5; border-radius: 4px; padding: 12px; box-sizing: border-box;">
                    <pre v-if="checkOrderBillJson"
                        style="margin: 0; white-space: pre-wrap; word-break: break-all;
                        font-family: Consolas, Monaco, 'Courier New', monospace; font-size: 12px;
                        line-height: 1.6; color: #303133;">{{ checkOrderBillJson }}</pre>
                    <span v-else style="color: #909399; font-size: 13px;">暂无关联数据</span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="closeCheckOrderBill">关 闭</el-button>
                </span>
            </el-dialog>
            <!-- 券码对账核查-扣减权益金弹窗（规格ID需用户输入） -->
            <el-dialog title="扣减权益金" :visible.sync="deductDialog" width="420px" :before-close="closeDeduct" append-to-body>
                <el-form :model="deductForm" label-width="80px" size="mini">
                    <el-form-item label="规格ID">
                        <el-input v-model="deductForm.specsId" placeholder="请输入规格ID" clearable />
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="closeDeduct">取 消</el-button>
                    <el-button size="mini" type="primary" @click="sureDeduct">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 券码对账核查-添加订单记录弹窗 -->
            <el-dialog title="添加订单记录" :visible.sync="orderRecordDialog" width="560px"
                :before-close="closeOrderRecord" append-to-body>
                <el-form :model="orderRecordForm" label-width="100px" size="mini">
                    <el-form-item label="商品编码" required>
                        <el-input v-model="orderRecordForm.specsSku" placeholder="请输入商品编码" clearable />
                    </el-form-item>
                    <el-form-item label="商品名称" required>
                        <el-input v-model="orderRecordForm.specsName" placeholder="请输入商品名称" clearable />
                    </el-form-item>
                    <el-form-item label="订单号">
                        <el-input v-model="orderRecordForm.orderNum" placeholder="请输入订单号(选填)" clearable />
                    </el-form-item>
                    <el-form-item label="子订单号">
                        <el-input v-model="orderRecordForm.orderNumSub" placeholder="请输入子订单号(选填)" clearable />
                    </el-form-item>
                    <el-form-item label="交易时间">
                        <el-date-picker v-model="orderRecordForm.createtime" type="datetime" size="mini"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择交易时间(选填)"
                            style="width: 100%" clearable />
                    </el-form-item>
                    <el-form-item label="扣减信息">
                        <el-input type="textarea" :rows="3" v-model="orderRecordForm.resultDeduct"
                            placeholder="移动侧扣减信息(选填)" />
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="closeOrderRecord">取 消</el-button>
                    <el-button size="mini" type="primary" @click="sureOrderRecord">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordExpandDetectorList, getAjefCertificateRecordRelationXiaoxiangList, getAjefShopListQuick, getAjefCertificateStatisticsCheckList, addAjefCertificateRecordMulti, updateAjefShop, cancelAjefCertificateRecordMulti, updateAjefCertificateRecordCopyCheckDes, getAjefCertificateRecordCopyCheckOrderBill, addAjefCertificateRecordCopyCheckBill, addAjefCertificateRecordCopyCheckOrder, addAjefCertificateRecordCopyCheckOrderRecord, getAjefCertificateRecordStatisticsYear } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAjefCertificateRecordRelationXiaoxiangList_data: [],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'acrId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            tableLoading: false,
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrYearMonth",
                    key: "acrYearMonth",
                    title: "制卡月份",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },

                {
                    field: "acrYearMonthExchange",
                    key: "acrYearMonthExchange",
                    title: "核销月份",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    fixed: 'left',
                    width: 200,
                },
                {
                    field: "asNumber",
                    key: "asNumber",
                    title: "商户编码",
                    align: "center",
                    fixed: 'left',
                    width: 90,
                },
                
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "卡劵金额",
                    fixed: 'left',
                    align: "center",
                    width: 100,
                },
                {
                    field: "asCity",
                    key: "asCity",
                    title: "商户地址",
                    align: "center",
                    width: 200,
                },
                // {
                //     field: "specificationXiaoxiang",
                //     key: "specificationXiaoxiang",
                //     title: "小象规格id",
                //     fixed: 'left',
                //     align: "center",
                //     width: 120,
                // },
                {
                    field: "acrCode",
                    key: "acrCode",
                    title: "卡劵号码",
                    align: "center",
                    width: 250,
                },
                {
                    field: "acrCodeType",
                    key: "acrCodeType",
                    title: "劵码类型",
                    align: "center",
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrCodeType == 1 ? '普通' :
                                        row.acrCodeType == 2 ? '烟感' : ''
                                }
                                {
                                    row.acrCodeType == 2 ? <el-button type="text" size="mini" style="margin-left: 10px" on-click={() => this.showDetail(row)}>附加信息</el-button> : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "acrExchangeDes",
                    key: "acrExchangeDes",
                    title: "核销备注",
                    align: "center",
                    width: 180,
                },
                // 商超类型商户核销时填写的超市购物卡号
                {
                    field: "acrExchangeShopCard",
                    key: "acrExchangeShopCard",
                    title: "超市购物卡号",
                    align: "center",
                    width: 160,
                },
                {
                    field: "acrExchangeRatio",
                    key: "acrExchangeRatio",
                    title: "核销分账比例(10000%)",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeShop",
                    key: "acrExchangeShop",
                    title: "商铺分账金额(1000/分)",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeTime",
                    key: "acrExchangeTime",
                    title: "核销时间",
                    align: "center",
                    width: 160,
                },
                {
                    field: "acrExchangeUserName",
                    key: "acrExchangeUserName",
                    title: "核销用户",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeUserBelong",
                    key: "acrExchangeUserBelong",
                    title: "核销用户门店",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrExchangeImages",
                    key: "acrExchangeImages",
                    title: "卡劵核销实物截图",
                    align: "center",
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        //查看详情
                                        row.acrExchangeImages ? <el-button type="text" size="mini" style="margin-left: 10px;"
                                            onClick={() => this.$emit('child-call', row.acrExchangeImages.split(','))}>查看详情</el-button> : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "acrPhone",
                    key: "acrPhone",
                    title: "领取手机号",
                    align: "center",
                    width: 140,
                },
                {
                    field: "acrGetTime",
                    key: "acrGetTime",
                    title: "领取时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "specificationXiaoxiang",
                    key: "specificationXiaoxiang",
                    title: "小象id",
                    align: "center",
                    width: 180,
                },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrStatus == 0 ? <el-tag size="mini" type="info">已撤销</el-tag> :
                                        row.acrStatus == 1 ? <el-tag size="mini" type="warning">创建</el-tag> :
                                            row.acrStatus == 2 ? <el-tag size="mini" >第三方导入</el-tag> :
                                                row.acrStatus == 3 ? <el-tag size="mini" >第三方领取</el-tag> :
                                                    row.acrStatus == 4 ? <el-tag size="mini" type="success">已核销</el-tag> : row.acrStatus == 5 ? <el-tag size="mini" type="success">分账</el-tag> : <el-tag type="danger" size="mini">退款</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "acrCheckHandlerStatus",
                    key: "acrCheckHandlerStatus",
                    title: "对账核查状态",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 0不需要 1待处理 2已处理 3有问题 4已解决
                        return (
                            <span>
                                {
                                    row.acrCheckHandlerStatus == 0 ? <el-tag size="mini" type="info">不需要</el-tag> :
                                        row.acrCheckHandlerStatus == 1 ? <el-tag size="mini" type="warning">待处理</el-tag> :
                                            row.acrCheckHandlerStatus == 2 ? <el-tag size="mini" type="success">已处理</el-tag> :
                                                row.acrCheckHandlerStatus == 3 ? <el-tag size="mini" type="danger">有问题</el-tag> :
                                                    row.acrCheckHandlerStatus == 4 ? <el-tag size="mini" type="success">已解决</el-tag> : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "acrCheckHandlerDes",
                    key: "acrCheckHandlerDes",
                    title: "对账核查描述",
                    align: "center",
                    width: 160,
                },
                {
                    field: "operation",
                    key: "operation",
                    title: "操作",
                    align: "center",
                    fixed: 'right',
                    width: 340,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // checkOperateAuth：仅 auId 为 1 或 2 的用户可见今日新增的操作按钮
                        // 对账核查状态为「3 有问题」时才展示「处理」按钮
                        const showHandle = row.acrCheckHandlerStatus == 3;
                        const auth = this.checkOperateAuth;
                        return (
                            <span>
                                {
                                    (auth && showHandle) ? <el-button type="text" size="mini"
                                        on-click={() => this.openCheckHandler(row)}>处理</el-button> : ''
                                }
                                {
                                    auth ? <el-button type="text" size="mini" style="margin-left: 8px"
                                        on-click={() => this.openCheckOrderBill(row)}>关联订单账单</el-button> : ''
                                }
                                {
                                    auth ? <el-button type="text" size="mini" style="margin-left: 8px"
                                        on-click={() => this.addCheckBill(row)}>添加账单</el-button> : ''
                                }
                                {
                                    auth ? <el-button type="text" size="mini" style="margin-left: 8px"
                                        on-click={() => this.addCheckOrder(row)}>扣减权益金</el-button> : ''
                                }
                                {
                                    auth ? <el-button type="text" size="mini" style="margin-left: 8px"
                                        on-click={() => this.openOrderRecord(row)}>添加订单记录</el-button> : ''
                                }
                            </span>
                        );
                    },
                },

                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},
            // 券码对账核查-处理弹窗
            checkHandlerDialog: false,
            // 处理模式：single 单条 / batch 批量
            checkHandlerMode: 'single',
            checkHandlerForm: {
                acrIds: '',
                acrCheckHandlerStatus: 4,
                acrCheckHandlerDes: '',
            },
            // 券码对账核查-扣减权益金弹窗（specsId 需用户手动输入）
            deductDialog: false,
            deductForm: {
                acrId: '',
                specsId: '',
            },
            // 券码对账核查-关联订单账单弹窗
            checkOrderBillDialog: false,
            checkOrderBillLoading: false,
            checkOrderBillJson: '',    // 关联订单/账单完整响应（JSON 文本）
            checkOrderBillRow: {},     // 当前操作的券记录行
            // 券码对账核查-添加订单记录弹窗
            orderRecordDialog: false,
            orderRecordForm: {
                acrId: '',
                specsSku: '',
                specsName: '',
                orderNum: '',
                orderNumSub: '',
                resultDeduct: '',
                createtime: '',
            },

        };
    },
    computed: {
        // 券码对账核查操作权限：仅 auId 为 1 或 2 的用户可见操作按钮
        checkOperateAuth() {
            const auId = Number(this.$store.state.Qy_userId);
            return auId === 1 || auId === 2;
        },
    },
    activated() {
        // 表格高度由 ResizeObserver 实测管理(见 mounted),进入页面时容器尺寸变化会自动触发
    },
    created() {
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        getAjefCertificateRecordRelationXiaoxiangList({ pageSize: 0 }).then(res => {
            this.getAjefCertificateRecordRelationXiaoxiangList_data = res.data
        })
        this.getList();
    },
    mounted() {
        // 表格高度自适应:flex 布局保证 table-wrap 占满剩余空间,ResizeObserver 实测喂给 ve-table
        this.tableResizeObserver = new ResizeObserver(() => {
            const wrap = this.$refs.tableWrap;
            if (!wrap) return;
            const h = wrap.clientHeight - 4;
            if (h > 200 && h !== this.tableHight) this.tableHight = h;
        });
        if (this.$refs.tableWrap) this.tableResizeObserver.observe(this.$refs.tableWrap);
    },
    destroyed() {
        if (this.tableResizeObserver) this.tableResizeObserver.disconnect();
    },
    methods: {
        showDetail(row) {
            this.openLoading()
            getAjefCertificateRecordExpandDetectorList({ asId: row.asId, acrCode: row.acrCode }).then(res => {
                this.loadings.close()
                this.tableDataDetail = res.data
                this.diaDetail = true
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-statistics-check/exportAjefCertificateStatisticsCheck',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '核销统计.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ acrId: this.theRow.acrId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ acrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    cancelAjefCertificateRecordMulti({ acrIds: row.acrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefCertificateRecordMulti(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShop(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acrId = row.acrId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefCertificateStatisticsCheckList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        // 打开券码对账核查-处理弹窗（单条，回填当前行信息）
        openCheckHandler(row) {
            this.checkHandlerMode = 'single';
            this.checkHandlerForm = {
                // acrIds 以数组形式存储，提交时再 JSON.stringify
                acrIds: [row.acrId],
                acrCheckHandlerStatus: 4,
                acrCheckHandlerDes: row.acrCheckHandlerDes || '',
            };
            this.checkHandlerDialog = true;
        },
        // 打开批量核查处理弹窗（多选，传入所选行 id 集合）
        openCheckHandlerBatch() {
            if (this.selectedRowKeysCollection.length === 0) {
                this.$message({ type: 'warning', message: '请先选择需要处理的数据' });
                return;
            }
            this.checkHandlerMode = 'batch';
            this.checkHandlerForm = {
                // 多选 id 集合，提交时 JSON.stringify
                acrIds: [...this.selectedRowKeysCollection],
                acrCheckHandlerStatus: 4,
                acrCheckHandlerDes: '',
            };
            this.checkHandlerDialog = true;
        },
        // 关闭核查处理弹窗
        closeCheckHandler() {
            this.checkHandlerDialog = false;
        },
        // 提交核查处理：更新对账核查状态与描述
        sureCheckHandler() {
            // 用 == null 同时拦截 null/undefined，放行合法值 0（不需要），避免 !0 误判
            if (this.checkHandlerForm.acrCheckHandlerStatus == null) {
                this.$message({ type: 'warning', message: '请选择核查状态' });
                return;
            }
            this.$confirm("是否确认提交核查处理, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                // acrIds 要求：数组并 JSON.stringify 后发送
                const params = {
                    acrIds: JSON.stringify(this.checkHandlerForm.acrIds),
                    acrCheckHandlerStatus: this.checkHandlerForm.acrCheckHandlerStatus,
                    acrCheckHandlerDes: this.checkHandlerForm.acrCheckHandlerDes,
                };
                updateAjefCertificateRecordCopyCheckDes(params).then((res) => {
                    if (res.data || res.data ==0) {
                        this.$message({ type: "success", message: "处理成功!" });
                        this.closeCheckHandler();
                        // 批量处理成功后清空多选状态
                        if (this.checkHandlerMode === 'batch') {
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                        }
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 打开关联订单/账单弹窗，并查询数据
        openCheckOrderBill(row) {
            this.checkOrderBillRow = row;
            this.checkOrderBillDialog = true;
            this.queryCheckOrderBill(row.acrId);
        },
        // 查询关联的订单和账单（接口返回完整结构，以 JSON 形式展示）
        queryCheckOrderBill(acrId) {
            this.checkOrderBillLoading = true;
            this.checkOrderBillJson = '';
            getAjefCertificateRecordCopyCheckOrderBill({ acrId }).then((res) => {
                this.checkOrderBillLoading = false;
                // 将完整响应（含 data 主对象 + item 账单数组）格式化为 JSON 文本展示
                this.checkOrderBillJson = res ? JSON.stringify(res, null, 2) : '';
            }).catch(() => {
                this.checkOrderBillLoading = false;
            });
        },
        // 关联订单账单-添加账单（表格操作列触发）
        addCheckBill(row) {
            this.$confirm("是否确认添加账单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                addAjefCertificateRecordCopyCheckBill({ acrId: row.acrId }).then((res) => {
                    if (res.data) {
                        this.$message({ type: "success", message: "添加账单成功!" });
                        this.getList();
                        // 若关联弹窗正处于打开状态，同步刷新关联列表
                        if (this.checkOrderBillDialog && this.checkOrderBillRow.acrId === row.acrId) {
                            this.queryCheckOrderBill(row.acrId);
                        }
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 关联订单账单-扣减权益金（打开输入弹窗，specsId 需用户填写）
        addCheckOrder(row) {
            this.deductForm = {
                acrId: row.acrId,
                specsId: '',
            };
            this.deductDialog = true;
        },
        // 关闭扣减权益金弹窗
        closeDeduct() {
            this.deductDialog = false;
        },
        // 提交扣减权益金
        sureDeduct() {
            if (this.deductForm.specsId === '' || this.deductForm.specsId == null) {
                this.$message({ type: 'warning', message: '请输入规格ID' });
                return;
            }
            this.$confirm("是否确认扣减权益金, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                addAjefCertificateRecordCopyCheckOrder(this.deductForm).then((res) => {
                    if (res.data) {
                        this.$message({ type: "success", message: "扣减权益金成功!" });
                        this.closeDeduct();
                        this.getList();
                        // 若关联弹窗正处于打开状态，同步刷新关联列表
                        if (this.checkOrderBillDialog && this.checkOrderBillRow.acrId === this.deductForm.acrId) {
                            this.queryCheckOrderBill(this.deductForm.acrId);
                        }
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 打开添加订单记录弹窗
        openOrderRecord(row) {
            this.orderRecordForm = {
                acrId: row.acrId,
                specsSku: '',
                specsName: '',
                orderNum: '',
                orderNumSub: '',
                resultDeduct: '',
                createtime: '',
            };
            this.orderRecordDialog = true;
        },
        // 关闭添加订单记录弹窗
        closeOrderRecord() {
            this.orderRecordDialog = false;
        },
        // 提交添加订单记录（specsSku、specsName 必填）
        sureOrderRecord() {
            if (!this.orderRecordForm.specsSku) {
                this.$message({ type: 'warning', message: '请输入商品编码' });
                return;
            }
            if (!this.orderRecordForm.specsName) {
                this.$message({ type: 'warning', message: '请输入商品名称' });
                return;
            }
            this.$confirm("是否确认添加订单记录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                addAjefCertificateRecordCopyCheckOrderRecord(this.orderRecordForm).then((res) => {
                    if (res.data) {
                        this.$message({ type: "success", message: "添加订单记录成功!" });
                        this.closeOrderRecord();
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 关闭关联订单账单弹窗
        closeCheckOrderBill() {
            this.checkOrderBillDialog = false;
            this.checkOrderBillJson = '';
            this.checkOrderBillRow = {};
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
<style scoped>
/* flex 高度链:筛选卡(shrink 0) -> tablemain(flex 1) -> table-wrap(flex 1),ve-table max-height 由 ResizeObserver 实测 */
.tablemain {
    margin: 0 auto;
    flex: 1;
    min-height: 0;
    height: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tablecss {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.table-wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.table-pagination {
    flex-shrink: 0;
    margin-top: 8px;
    margin-bottom: 4px;
}
</style>